import { apiClient } from './setupApi';

const partners = '/partners';
const promotions = '/partners/promotions';

export const requestGetPartners = async (payload) => {
  const { data } = await apiClient.get(`${partners}`, {
    params: {
    ...payload
    }
  });
  return data;
};

export const requestGetPartnersList = async (payload) => {
  const { data } = await apiClient.get(`${partners}/names`, {
    params: {
      ...payload
    }
  });
  return data;
};

export const requestGetPartner = async (id) => {
  const { data } = await apiClient.get(`${partners}/${id}`);
  return data;
};

export const requestCreatePartner = async (payload) => {
  const { data } = await apiClient.post(`${partners}`, payload);
  return data;
};

export const requestUpdatePartner = async (id, payload) => {
  const { data } = await apiClient.patch(`${partners}/${id}`, payload);
  return data;
};

export const requestGetCities = async (payload) => {
  const data = await apiClient.get(`${partners}/city`, {
    params: {
      ...payload
    }
  });
  return data;
};

export const requestUploadLogo = async (file) => {
  const { data } = await apiClient.post(`${partners}/logo`, file);
  return data;
};

export const requestGetPromotions = async (payload) => {
  const { data } = await apiClient.get(`${promotions}`, {
    params: {
      ...payload
    }
  });
  return data;
};

export const requestGetPromotion = async (id) => {
  const { data } = await apiClient.get(`${promotions}/${id}`);
  return data;
};

export const requestCreatePromotion = async (payload) => {
  const { data } = await apiClient.post(`${promotions}`, payload);
  return data;
};

export const requestUpdatePromotion = async (id, payload) => {
  const { data } = await apiClient.patch(`${partners}/promotions/${id}`, payload);
  return data;
};

export const requestGetPackages = async (payload) => {
  return await apiClient.get(`${promotions}/packages`, {
    params: {
      ...payload
    }
  });
};

export const requestGetCustomerFiles = async (id, payload) => {
  const { data } = await apiClient.get(`${promotions}/${id}/files`, payload ? {
    params: {
      ...payload
    }
  } : undefined);
  return data;
};

export const requestGetCustomerFile = async (id) => {
  const { data } = await apiClient.get(`${promotions}/file/${id}`);
  return data;
};

export const requestGetPromoFiles = async (id) => {
  const { data } = await apiClient.get(`${promotions}/${id}/files/promocodes`);
  return data;
};

export const requestUploadFile = async (file) => {
  const { data } = await apiClient.post(`${promotions}/file`, file);
  return data;
};

export const requestUploadPartnerFile = async (file, id) => {
  const { data } = await apiClient.post(`${promotions}/${id}/file`, file);
  return data;
};

export const requestUploadPromoCodeFile = async (file) => {
  const { data } = await apiClient.post(`${promotions}/file/promocode`, file);
  return data;
};

export const requestUploadPromoCodeFileId = async (file, id) => {
  const { data } = await apiClient.post(`${promotions}/${id}/file/promocode`, file);
  return data;
};

export const requestDeletePartnerFile = async (id, file_id) => {
  const { data } = await apiClient.delete(`${promotions}/${id}/file/${file_id}`);
  return data;
};

export const requestDeletePromoCodeFile = async (id, file_id) => {
  const { data } = await apiClient.delete(`${promotions}/${id}/file/promocode/${file_id}`);
  return data;
};

export const requestArchivePartner = async (id) => {
  const { data } = await apiClient.patch(`${partners}/${id}/status`, { status: 'Архив' });
  return data;
}

export const requestUnarchivePartner = async (id) => {
  const { data } = await apiClient.patch(`${partners}/${id}/status`, { status: 'Действующий' });
  return data;
}

export const requestArchivePromotion = async (id) => {
  const { data } = await apiClient.patch(`${promotions}/${id}/status`, { status: 'Архив' });
  return data;
}

export const requestGetPromoCodes = async (payload) => {
  const { data } = await apiClient.get(`${promotions}/promocodes`, {
    params: {
      ...payload
    }
  });
  return data;
}

export const requestCopyPromotion = async (id) => {
  const { data } = await apiClient.get(`${promotions}/${id}/copy`);
  return data;
}

export const requestUpdatePartnersPositions = async (postions) => {
  const { data } = await apiClient.patch(`${partners}/positions`, postions);
  return data;
}

export const requestUpdatePromotionsPositions = async (postions) => {
  const { data } = await apiClient.patch(`${promotions}/positions`, postions);
  return data;
}